import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-empty-state-admin',
    templateUrl: './empty-state-admin.component.html',
    styleUrls: ['./empty-state-admin.component.scss'],
    standalone: false
})
export class EmptyStateAdminComponent {
  @Input() title?: string;
  @Input() message?: string;

}
